import clsx from "clsx";

export type VisibilityScope = "me" | "team" | "all";

const OPTIONS: { value: VisibilityScope; label: string }[] = [
  { value: "me", label: "Me" },
  { value: "team", label: "My team" },
  { value: "all", label: "Everyone" },
];

export interface VisibilityFilterProps {
  value: VisibilityScope;
  onChange: (value: VisibilityScope) => void;
  className?: string;
  "data-testid"?: string;
}

/** Me / My team / Everyone scope control for agentic lists. */
export function VisibilityFilter({
  value,
  onChange,
  className,
  "data-testid": testId = "visibility-filter",
}: VisibilityFilterProps) {
  return (
    <div
      className={clsx(
        "inline-flex rounded-lg border border-slate-200 bg-slate-100 p-0.5 dark:border-slate-700/80 dark:bg-slate-900/50",
        className
      )}
      data-testid={testId}
      role="group"
      aria-label="Visibility"
    >
      {OPTIONS.map((opt) => (
        <button
          key={opt.value}
          type="button"
          aria-label={`${opt.label} visibility`}
          className={clsx(
            "px-3 py-1.5 text-xs font-medium rounded-md transition-colors",
            value === opt.value
              ? "bg-slate-700 text-white shadow-sm dark:bg-slate-600 dark:text-white"
              : "text-slate-600 hover:text-slate-900 dark:text-slate-400 dark:hover:text-slate-200"
          )}
          aria-pressed={value === opt.value}
          onClick={() => onChange(opt.value)}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}
